import React from 'react';
import { CacheProvider } from '@emotion/react';
import { StaticRouter, BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import SharedApp from './SharedApp';
import theme from '../themes/defaultTheme';
import { NurseryProvider } from '../contexts/NurseryContext';
import { SearchProvider } from '../contexts/SearchContext';
var ServerApp = function (_a) {
    var data = _a.data, cache = _a.cache, location = _a.location, _b = _a.queryParams, queryParams = _b === void 0 ? {} : _b;
    return (React.createElement(CacheProvider, { value: cache },
        React.createElement(ThemeProvider, { theme: theme },
            React.createElement(CssBaseline, null),
            typeof window !== 'undefined' ? (
            // On the server we render with StaticRouter for SSR; once hydrated in the browser
            // we switch to BrowserRouter so client-side navigation (history.push, back/forward)
            // updates location and triggers lifecycle hooks.
            React.createElement(BrowserRouter, null,
                React.createElement(NurseryProvider, null,
                    React.createElement(SearchProvider, null,
                        React.createElement(SharedApp, { data: data }))))) : (React.createElement(StaticRouter, { context: queryParams, location: location },
                React.createElement(NurseryProvider, null,
                    React.createElement(SearchProvider, null,
                        React.createElement(SharedApp, { data: data }))))))));
};
export default ServerApp;
